import { Plugin } from 'vue';
import { setup } from '@ilteducation/localisation-vue3';
import devLanguage from '@/locale/dev';
import supportedLanguages from './supported-languages';

const defaultLanguageName = 'dev';

export const { i18n, useLocalisation, useLocale } = setup({
  appName: 'Manabua',
  defaultLanguageName,
  defaultLanguage: devLanguage,
  supportedLanguages,
});

// This is a workaround to make the i18n object compatible with Vue 3 plugins.
export default i18n as unknown as Plugin;
